export default __webpack_public_path__ + "static/media/peep-59.40032368.svg";